export default __webpack_public_path__ + "static/media/arrival-banner-2.73e5e1a8.jpg";